export const queryKeys = {
  users: {
    me: ['users', 'me'] as const,
  },
  subscriptions: {
    all: ['subscriptions'] as const,
  },
  affiliatedOrganizations: {
    all: (params?: { limit?: number; offset?: number; ordering?: string; search?: string }) =>
      ['affiliatedOrganizations', params] as const,
  },
  organizationMembers: {
    list: (organizationId: string, params?: { limit?: number; offset?: number }) =>
      ['organizationMembers', organizationId, params] as const,
  },
  cms: {
    scientificCorpora: (params?: { limit?: number; offset?: number }) =>
      ['cms', 'scientificCorpora', params] as const,
    teamCategories: (params?: { limit?: number; offset?: number }) =>
      ['cms', 'teamCategories', params] as const,
    teamMembers: (params?: { limit?: number; offset?: number }) =>
      ['cms', 'teamMembers', params] as const,
    faq: (params?: { limit?: number; offset?: number }) => ['cms', 'faq', params] as const,
  },
} as const
